module.exports = __webpack_public_path__ + "static/media/Refresh_round.d17c4e25.svg";